import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const dispatchClaimDetails = (data) => ({
  type: actionTypes.GET_CLAIM_DETAILS,
  claimDetails: data,
});

export const setClaimDetailsId = (payload) => {
  return { type: actionTypes.CLAIM_DETAILS_ID, payload };
};

export const getClaimDetails = (claimObj) => {
  return (dispatch, getState) => {
    const userId =
      getState().sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
        ?.userId;
    axios
      .post(serviceEndPoint.GET_CLAIM_DETAILS, {
        claimId: claimObj && claimObj.claimId,
        claimLineNum: claimObj && claimObj.claimLineNum,
        userID: userId,
        //userLastName: 'TEST',
        functionCode: claimObj?.functionCode || 'Claim',
        eventInquryKeyVO: [
          {
            keyType: 'Claim ID',
            key: `${claimObj.claimId}-${claimObj.claimLineNum}`,
          },
        ],
      })
      .then((response) => {
        const data = response?.data;
        let claimDetailData = {
          [claimObj?.claimId]: data,
        };
        dispatch(dispatchClaimDetails(claimDetailData));
      })
      .catch((error) => {
        dispatch(dispatchClaimDetails({ error: 'API failed' }));
      });
  };
};
